import { render, staticRenderFns } from "./DashboardAppModal.vue?vue&type=template&id=f53e1d1e&"
import script from "./DashboardAppModal.vue?vue&type=script&lang=js&"
export * from "./DashboardAppModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports